// 这里做一个静态标记
// 因为请求的路径是 https://pan.xunlei.com/yc/dev
// 但是部署的是具体某一个厂商的代码；测试的时候可能会有问题
// 涉及到实际厂商app打开判断逻辑都应该依赖这个变量，而不是 location.pathname
export const platformPath: PathEnv = ''